import React from 'react';

import { OpportunityDetailsCard } from '..';

import { DashboardV3ProjectHeader } from './DashboardV3ProjectHeader';
import '../oneButton-css/DashboardProjectHeaderSlot.css';

import '../oneButton-css/DashboardV3LayoutSection.css';



export type DashboardOpportunityHeaderBlockProps = {

    theme: 'dark' | 'light';

    loading: boolean;

    opportunityId: string;

    opportunityName: string;

    stageStatus: string;

    stageNumber: string;

    utilityCompany: string;

    siteAddress: any;

    refreshKey: number;

    isTitleContactExist?: boolean | null;

    onAddTitleContactsClick?: () => void;

    onBlackKnightTitleCheckClick?: () => void;

};



/** V3-style project header + hidden opportunity card preload (split / masonry dashboard). */

export const DashboardOpportunityHeaderBlock: React.FC<DashboardOpportunityHeaderBlockProps> = ({

    theme,

    loading,

    opportunityId,

    opportunityName,

    stageStatus,

    stageNumber,

    utilityCompany,

    siteAddress,

    refreshKey,

    isTitleContactExist,

    onAddTitleContactsClick,

    onBlackKnightTitleCheckClick,

}) => (

    <div className={`obd-masonry__item obd-masonry__item--wide obd-dashboard-project-header-slot obd-theme-${theme}`}>

        <div className="obd-dashboard-v3-layout__preload" aria-hidden>

            <OpportunityDetailsCard

                loading={loading}

                opportunityId={opportunityId}

                opportunityName={opportunityName}

                stageStatus={stageStatus}

                stageNumber={stageNumber}

                utilityCompany={utilityCompany}

                siteAddress={siteAddress}

                refreshKey={refreshKey}

            />

        </div>

        <DashboardV3ProjectHeader
            theme={theme}
            opportunityName={opportunityName}
            opportunityId={opportunityId}
            stageStatus={stageStatus}
            siteAddress={siteAddress}
            utilityCompany={utilityCompany}
            loading={loading}
            isTitleContactExist={isTitleContactExist}
            onAddTitleContactsClick={onAddTitleContactsClick}
            onBlackKnightTitleCheckClick={onBlackKnightTitleCheckClick}
        />

    </div>

);

